/* ==========================================
   SHOP MORE JS
   PART 1
========================================== */

document.addEventListener("DOMContentLoaded", function () {

    const builder = document.getElementById("shop-more-builder");

    if (!builder) return;

    

    /* ===============================
       OFFER SETTINGS
    =============================== */

    const STEP1 = 6;
    const STEP2 = 8;
    const STEP3 = 10;

    const CODE10 = "SAVEMORE10";
    const CODE15 = "SAVEMORE15";
    const CODE20 = "SAVEMORE20";

    /* ===============================
       STATE
    =============================== */

    let selectedProducts = [];

    /* ===============================
       ELEMENTS
    =============================== */

    const cards = document.querySelectorAll(".shop-more-card");

    const slots = document.querySelectorAll(".shop-more-slot");

    const progressFill =
        document.getElementById("shop-more-progress-fill");

    const selectedCount =
        document.getElementById("shop-more-selected-count");

    const message =
        document.getElementById("shop-more-message");

    const subtotal =
        document.getElementById("shop-more-final-price");

    const comparePrice =
        document.getElementById("shop-more-old-price");

    const saveText =
        document.getElementById("shop-more-save");

    const checkoutBtn =
        document.getElementById("shop-more-checkout");

    let activeCoupon = "";

    /* ===============================
       INIT
    =============================== */

    checkoutBtn.disabled = true;

    /* ===============================
       ADD PRODUCT
    =============================== */

    cards.forEach((card) => {

        const button =
            card.querySelector(".shop-more-add-btn");

        button.addEventListener("click", function () {

            const id = card.dataset.id;

            if (selectedProducts.find(p => p.id == id)) {

                return;

            }

          if (selectedProducts.length >= STEP3) {
    return;
}

            selectedProducts.push({

                id: id,

                variant: Number(card.dataset.variant),

                price: Number(card.dataset.price),

                image: card.querySelector("img").src,

                button: button

            });

            button.disabled = true;

            button.innerHTML = "Added ✓";

            refreshSlots();

            updateOffer();
            cards.forEach(card => {

    const btn = card.querySelector(".shop-more-add-btn");

    if (!btn) return;

    const alreadyAdded = selectedProducts.find(p => p.id == card.dataset.id);

    if (alreadyAdded) return;

    btn.disabled = selectedProducts.length >= STEP3;

});

        });

    });

        /* ===============================
       REMOVE PRODUCT
    =============================== */
document.addEventListener("click", function(e){

    if(!e.target.classList.contains("shop-more-remove")) return;

    const index = Number(e.target.dataset.index);

    if(!selectedProducts[index]) return;

    const product = selectedProducts[index];

    product.button.disabled = false;
    product.button.innerHTML = "Add To Box";

    selectedProducts.splice(index,1);

    refreshSlots();

    updateOffer();

});

    

    /* ===============================
       REFRESH SLOTS
    =============================== */

    function refreshSlots() {

        slots.forEach(slot => {

            slot.classList.remove("active");

            slot.innerHTML = '<span class="slot-plus">+</span>';

        });

        selectedProducts.forEach((product, index) => {

            if (!slots[index]) return;

            slots[index].classList.add("active");

            slots[index].innerHTML = `
    <img
        src="${product.image}"
        alt=""
        style="width:100%;height:100%;object-fit:cover;">

    <span class="shop-more-remove" data-index="${index}">
        ×
    </span>
`;

        });

        /* Show only required slots */

slots.forEach((slot, index) => {

    if (index < 6) {

        slot.style.display = "flex";

    } else if (index < 8) {

        slot.style.display = selectedProducts.length >= 6 ? "flex" : "none";

    } else {

        slot.style.display = selectedProducts.length >= 8 ? "flex" : "none";

    }

});

    }

    /* ===============================
       UPDATE OFFER
    =============================== */

    function updateOffer() {

        const count = selectedProducts.length;

        if (selectedCount) {

            selectedCount.textContent = count;

        }

       if (progressFill) {

   let progress = 0;

if (count <= STEP1) {

    progress = (count / STEP1) * 16.66;

}
else if (count <= STEP2) {

    progress = 16.66 + ((count - STEP1) / (STEP2 - STEP1)) * 33.33;

}
else {

    progress = 50 + ((count - STEP2) / (STEP3 - STEP2)) * 50;

}

progressFill.style.width = progress + "%";
       }
activeCoupon = "";

if (count >= STEP3) {

    activeCoupon = CODE20;

    message.innerHTML = `
        🎉 Coupon <strong>${CODE20}</strong> Applied for 10 Products
        <br>
        <small>🎉 Maximum Discount Unlocked</small>
    `;

}
else if (count >= STEP2) {

    activeCoupon = CODE15;

    message.innerHTML = `
        🎉 Coupon <strong>${CODE15}</strong> Applied for 8 Products
        <br>
        <small>Add ${STEP3 - count} more product(s) to get <strong>20% OFF</strong></small>
    `;

}
else if (count >= STEP1) {

    activeCoupon = CODE10;

    message.innerHTML = `
        🎉 Coupon <strong>${CODE10}</strong> Applied for 6 Products
        <br>
        <small>Add ${STEP2 - count} more product(s) to get <strong>15% OFF</strong></small>
    `;

}
else {

    message.innerHTML = `
        Add ${STEP1 - count} more product(s) to get <strong>10% OFF</strong>
    `;

}

        /* ===========================
   OFFER STATUS
=========================== */
/* ===========================
   OFFER STATUS
=========================== */

const offerTitle = document.getElementById("shop-more-offer-title");
const offerFill = document.getElementById("shop-more-offer-fill");
const offerStatus = document.getElementById("shop-more-offer-status");


if (offerTitle && offerFill) {

    if (count >= STEP3) {

        offerTitle.innerHTML =
            `🎉 Buy 10 at 20% OFF Applied<br><small>Maximum Discount Unlocked</small>`;

        offerFill.style.width = "100%";

    } else if (count >= STEP2) {

        offerTitle.innerHTML =
            `🎉 Buy 8 at 15% OFF Applied<br><small>Add ${STEP3 - count} More Item(s) to Unlock 20% OFF</small>`;

        offerFill.style.width = "80%";

    } else if (count >= STEP1) {

        offerTitle.innerHTML =
            `🎉 Buy 6 at 10% OFF Applied<br><small>Add ${STEP2 - count} More Item(s) to Unlock 15% OFF</small>`;

        offerFill.style.width = "60%";

    } else {

        offerTitle.innerHTML =
            `Add ${STEP1 - count} Product(s) to Get 10% OFF`;

        offerFill.style.width = ((count / STEP1) * 60) + "%";

    }

}

if (offerStatus) {
    offerStatus.style.display = "block";
}

updatePrice();
        /* Enable / Disable Add To Box Buttons */

cards.forEach(card => {

    const btn = card.querySelector(".shop-more-add-btn");

    if (!btn) return;

    const alreadyAdded = selectedProducts.some(
        product => product.id == card.dataset.id
    );

    if (alreadyAdded) {

        btn.disabled = true;
        btn.innerHTML = "Added ✓";

    } else {

        btn.disabled = selectedProducts.length >= STEP3;
        btn.innerHTML = "Add To Box";

    }

});

    }

        /* ===============================
       PRICE CALCULATION
    =============================== */

    function updatePrice() {

        let total = 0;

        selectedProducts.forEach(product => {

            total += product.price;

        });

        let discountPercent = 0;

        if (selectedProducts.length >= STEP3) {

            discountPercent = 20;

        } else if (selectedProducts.length >= STEP2) {

            discountPercent = 15;

        } else if (selectedProducts.length >= STEP1) {

            discountPercent = 10;

        }

        const discountAmount = total * discountPercent / 100;

        const finalTotal = total - discountAmount;

        if (subtotal) {

            subtotal.innerHTML = "₹" + finalTotal.toFixed(2);

        }

        if (comparePrice) {

            if (discountPercent > 0) {

                comparePrice.innerHTML =
                    "₹" + total.toFixed(2);

                comparePrice.style.display = "inline-block";

            } else {

                comparePrice.style.display = "none";

            }

        }

        if (saveText) {

            if (discountPercent > 0) {

                saveText.innerHTML =
                    `You Save ₹${discountAmount.toFixed(2)} (${discountPercent}% OFF)`;

            } else {

                saveText.innerHTML = "No Discount Applied";

            }

        }

        /* Checkout Button */

        if (checkoutBtn) {

            checkoutBtn.disabled =
                selectedProducts.length < STEP1;

        }

    }

    /* ===============================
       INITIAL LOAD
    =============================== */

    refreshSlots();

    updateOffer();

    /* ===============================
   SEARCH
=============================== */

const searchInput = document.getElementById("shop-more-search");
const searchIcon = document.querySelector(".shop-more-search-icon");

if (searchInput && searchIcon) {

    searchIcon.addEventListener("click", () => {

        searchInput.classList.add("active");
        searchInput.focus();
        searchIcon.style.display = "none";

    });

    searchInput.addEventListener("blur", () => {

        if (searchInput.value.trim() === "") {

            searchInput.classList.remove("active");
            searchIcon.style.display = "flex";

        }

    });

    searchInput.addEventListener("input", function () {
        console.log("Typing:", this.value);
        console.log("Typing:", this.value);
        const keyword = this.value.toLowerCase().trim();

/* Hide / Show Search Icon */

if (keyword.length > 0) {

    searchIcon.style.display = "none";

} else {

    searchIcon.style.display = "flex";

}

     

        cards.forEach(card => {
            
            console.log(card.querySelector(".shop-more-title"));
            const titleElement = card.querySelector(".shop-more-title");

const title = titleElement
    ? titleElement.textContent.toLowerCase()
    : "";
            if (title.includes(keyword)) {

                card.style.display = "";

            } else {

                card.style.display = "none";

            }

        });

    });

}

        /* ===============================
       CHECKOUT
    =============================== */

    if (checkoutBtn) {

        checkoutBtn.addEventListener("click", async function () {

            if (selectedProducts.length < STEP1) {

                alert(`Please select at least ${STEP1} products.`);

                return;

            }

            checkoutBtn.disabled = true;
            checkoutBtn.innerHTML = "Processing...";

            try {

                /* Clear Cart */

                await fetch("/cart/clear.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                });

                /* Prepare Cart Items */

                const items = [];

                selectedProducts.forEach(product => {

                    items.push({
                        id: product.variant,
                        quantity: 1
                    });

                });

                /* Add Products */

                const response = await fetch("/cart/add.js", {

                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({
                        items: items
                    })

                });

                if (!response.ok) {

                    throw new Error("Unable to add products.");

                }

                /* Coupon */

               /* Shiprocket Checkout */

if (typeof shiprocketCheckoutEvents !== "undefined") {

    checkoutBtn.disabled = false;
checkoutBtn.innerHTML = "Checkout";

    shiprocketCheckoutEvents.buyCart();

} else {

    window.location = "/checkout";

}
            }

            catch (error) {

                console.error(error);

                alert("Something went wrong. Please try again.");

                checkoutBtn.disabled = false;
                checkoutBtn.innerHTML = "Checkout";

            }

        });

    }

});